import { LOADSCRIPT_KEY } from "App";
import axios from "axios";
import { useEffect } from "react";
import Geocoder from "react-geocode";

namespace UseGeocoderPropsParams {
  export type GetFromCoords = {
    lat: string;
    lng: string;
  }
}

type ViaCepAddress = {
  bairro: string;
  cep: string;
  complemento: string;
  ddd: string;
  gia: string;
  ibge: string;
  localidade: string;
  logradouro: string;
  siafi: string;
  uf: string;
}

type FormattedAddress = {
  street?: string;
  street_number?: string;
  city?: string;
  uf?: string;
  country?: string;
}

type Address = {
  street: string;
  district: string;
  city: string;
  uf: string;
  postalCode: string;
  number: string;
}

export function useGeocoder() {
  useEffect(() => {
    Geocoder.setApiKey(LOADSCRIPT_KEY);
    Geocoder.setLanguage('br');
  }, []);

  async function getFromViaCep(components: google.maps.GeocoderAddressComponent[]) {
    return await axios.get(`https://viacep.com.br/ws/${components[3].short_name}/${components[2].long_name}/${components[0].long_name}/json/`
    )
  }

  async function getFromCoords({ lat, lng }: UseGeocoderPropsParams.GetFromCoords) {
    return await Geocoder.fromLatLng(lat, lng)
      .then((res) => res)
      .catch((err) => err);
  }

  function formatResultsToAddress(geocoderResults: any) {
    const result = {} as FormattedAddress;

    for (let addr of geocoderResults) {
      if (addr.types.includes("country")) {
        const value = addr.address_components.filter((el: any) =>
          el.types.includes("country")
        );
        result["country"] = value.length > 0 && value[0].long_name;
      }
      if (addr.types.includes("street_address")) {
        const value = addr.address_components.filter((el: any) =>
          el.types.includes("route")
        );
        const streetNumber = addr.address_components.filter((el: any) =>
          el.types.includes("street_number")
        );
        result["street"] = value.length > 0 && value[0].long_name;
        result["street_number"] =
          streetNumber.length > 0 && streetNumber[0].long_name;
      }
      if (addr.types.includes("administrative_area_level_1")) {
        const value = addr.address_components.filter((el: any) =>
          el.types.includes("administrative_area_level_1")
        );
        result["uf"] = value.length > 0 && value[0].long_name;
      }
      if (addr.types.includes("administrative_area_level_2")) {
        const value = addr.address_components.filter((el: any) =>
          el.types.includes("administrative_area_level_2")
        );
        result["city"] = value.length > 0 && value[0].long_name;
      }
    }

    return result;
  }

  async function formatGoogleComponentsToAddress(
    addressComponents: google.maps.GeocoderAddressComponent[]
  ): Promise<string | Address>  {
    const addressCount = addressComponents.length;    
    try {
      switch (addressCount) {
        case 3:
          return {
            street: "sem rua",
            district: "sem bairro",
            city: addressComponents[0].long_name,
            uf: addressComponents[1].short_name,
            postalCode: "sem cep",
            number: "",
          }
        case 4:
          return {
            street: addressComponents[0].long_name,
            district: addressComponents[0].long_name,
            city: addressComponents[0].long_name,
            uf: addressComponents[1].short_name,
            postalCode: addressComponents[3].long_name,
            number: "",
          }
        case 5: 
        return {
          street: addressComponents[0].long_name,
          district: addressComponents[1].long_name,
          city: addressComponents[2].long_name,
          uf: addressComponents[3].short_name,
          postalCode:  addressComponents[4].short_name,
          number: "",
        }
          // // const response = await getFromViaCep(addressComponents);
          // if (response.data && response.data.length > 0) {
          //   const rawAddressComponents = addressComponents.map((address) => address.long_name);

          //   for (const address of response.data) {
          //     if (rawAddressComponents.includes(address.bairro)) {
   
          //     }
          //   }

          //   throw new Error('Geocoder => Não foi possível encontrar o endereço selecionado!');
          // }

          // throw new Error('Geocoder => Não foi possível recuperar os dados do CEP');
        case 6:
          return {
            number: "",
            street: addressComponents[0].long_name,
            district: addressComponents[1].long_name,
            city: addressComponents[2].long_name,
            uf: addressComponents[3].short_name,
            postalCode: addressComponents[5].long_name,
          }
        case 7: 
          return {
            number: addressComponents[0].long_name,
            street: addressComponents[1].long_name,
            district: addressComponents[2].long_name,
            city: addressComponents[3].long_name,
            uf: addressComponents[4].short_name,
            postalCode: addressComponents[6].long_name,
          }
        case 8: 
          return {
            number: addressComponents[1].long_name,
            street: addressComponents[2].long_name,
            district: addressComponents[3].long_name,
            city: addressComponents[4].long_name,
            uf: addressComponents[5].short_name,
            postalCode: addressComponents[7].long_name,
          }
        default: 
          throw new Error('Endereço inválido!');
      }
    } catch (error) {
      console.log('useGeocoder => formatGoogleError', error)

      if (addressCount < 5) {
        return 'Seja mais específico ao digitar o endereço.';
      }

      return 'Não foi possível recuperar as coordenadas desse endereço. Seja mais específico (exemplo: adicione o número) ou tente novamente.'
    }
  }

  function parseAddressToString(address: Address) {
    return `${address.street}, ${address.street}`
  }

  return {
    getFromCoords,
    formatResultsToAddress,
    formatGoogleComponentsToAddress,
    parseAddressToString
  }
}